import { render, staticRenderFns } from "./scarlettFooter.vue?vue&type=template&id=adc445c8&scoped=true"
import script from "./scarlettFooter.vue?vue&type=script&lang=js"
export * from "./scarlettFooter.vue?vue&type=script&lang=js"
import style0 from "./scarlettFooter.vue?vue&type=style&index=0&id=adc445c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adc445c8",
  null
  
)

export default component.exports